module.exports = __webpack_public_path__ + "img/16.b3768a5d.jpg";